import React from 'react'

import './FancyWord.scss'

interface IFancyWord {
    text: string
    type?: 'no-underline' | 'straight' | 'curve'
}

const FancyWord = ({ text, type }: IFancyWord): React.ReactElement => (
    <div
        className={`fancy_text ${
            type === 'no-underline' ? 'no_underline' : ''
        } ${type === 'straight' ? 'straight' : ''}`}
        data-text={text}
    >
        {text}
    </div>
)

FancyWord.defaultProps = {
    type: 'curve',
}

export default FancyWord
